const ErrorMessage = ({ message, messages }: any) => {
  return (
    <>
      {message && (
        <p className="mb-5 rounded bg-red-300 p-4 text-center">{message}</p>
      )}

      {messages && (
        <>
          {messages.map((error: any) => (
            <p key={error} className="mb-5 rounded bg-red-300 p-4 text-start">
              {error}
            </p>
          ))}
        </>
      )}
    </>
  );
};

export default ErrorMessage;
